import React, { useState, useEffect } from 'react'
import './Navbar.css';
import { useLocation, Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { IoIosArrowDown } from "react-icons/io";
import { FaBars } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import BrandLogo from '../../assets/images/logo2n.png';
import { FaArrowRightLong } from "react-icons/fa6";

// Single source of truth for the services mega-menu.
// Each id MUST match a section id in src/pages/Services.jsx.
const SERVICE_PILLARS = [
  {
    pillar: 'AI Solutions',
    items: [
      { id: 'ai-agents', label: 'AI Agents: Voice, Sales & Support', blurb: 'AI voice and chat agents on AWS Bedrock. Automate support, qualify leads, and run 24/7.' },
      { id: 'generative-ai-development', label: 'Generative AI Development', blurb: 'Custom LLM, RAG, and agentic AI systems built on AWS Bedrock, from proof of concept to production.' },
      { id: 'ai-automation', label: 'AI Automation', blurb: 'Automate manual workflows, approvals, and document processing with AI-driven automation on AWS.' },
      { id: 'ai-consulting', label: 'AI Consulting & Use-Case Roadmapping', blurb: 'AI readiness assessments and use-case roadmaps that pinpoint where AI delivers real ROI.' },
    ],
  },
  {
    pillar: 'Cloud & DevOps',
    items: [
      { id: 'cloud-migration-modernization', label: 'Cloud Migration & Modernization', blurb: 'Migrate and modernize legacy systems on AWS with zero business disruption.' },
      { id: 'aws-managed-services', label: 'AWS Managed Services & FinOps', blurb: '24/7 AWS monitoring, security, and cost management (FinOps) for your infrastructure.' },
      { id: 'cloud-security-audits', label: 'Cloud Security & Best-Practice Audits', blurb: 'Independent audits of your AWS environment against security, reliability, and cost best practices.' },
      { id: 'devops-platform-engineering', label: 'DevOps & Platform Engineering', blurb: 'CI/CD pipelines, Kubernetes, and infrastructure as code for faster, safer releases on AWS.' },
    ],
  },
  {
    pillar: 'Software & Data Engineering',
    items: [
      { id: 'custom-software-web-applications', label: 'Custom Software Web & Mobile Applications', blurb: 'Tailored, scalable web and mobile applications built natively on AWS, from design to launch.' },
      { id: 'backend-api-integration', label: 'Backend & API Integration', blurb: 'High-performance backend systems and API integrations that connect your tools on AWS.' },
      { id: 'data-engineering-analytics', label: 'Data Engineering & Analytics', blurb: 'Data pipelines, BI dashboards, and AI-driven analytics that turn data into decisions.' },
    ],
  },
  {
    pillar: 'Technology Consulting',
    items: [
      { id: 'cloud-digital-transformation-strategy', label: 'Cloud & Digital Transformation Strategy', blurb: 'Cost-aware cloud and digital transformation roadmaps aligned with business outcomes.' },
      { id: 'cto-advisory-architecture-consulting', label: 'CTO Advisory & Architecture Consulting', blurb: 'Senior technology leadership and architecture consulting without a full-time CTO hire.' },
    ],
  },
];

export default function NavigationBar({ menuOpen, setMenuOpen }) {

  // Mobile mega-menu toggle and the currently selected pillar (by index).
  const [megaShow, setMegaShow] = useState(false);
  const [activePillar, setActivePillar] = useState(0);

  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <nav>
        <div className='navbar'>
            <div className="logo fw-bold">
                {/* The mark is decorative here — the wordmark beside it names the
                    company, so alt text would have a screen reader read it twice. */}
                <Link to='/' className='brand-logo'>
                    <img src={BrandLogo} alt="" />
                    <span className='brand-text'>
                        <span className='brand-wordmark'>
                            {/* The explicit space keeps the link's accessible name
                                "Jaggulas Consulting" rather than one run-on word. */}
                            Jaggulas{' '}
                            <span className='brand-wordmark-sub'>Consulting</span>
                        </span>
                        {/* Hidden from assistive tech: it is a strapline, not part
                            of what this link is, and it would otherwise be read out
                            on top of the company name on every page. */}
                        <span className='brand-tagline' aria-hidden='true'>Empowering strategies exceeding expectations</span>
                    </span>
                </Link>
            </div>

            <ul className= {"nav-links " + (menuOpen && "show")}>
                <div className='btn cancel-btn ms-2'>
                    <FaTimes  onClick={() => setMenuOpen (false)}/>
                </div>

                <li>
                     {/* For Desktop view */}
                     <Link to='/Services ' className="nav-link desktop-item"> Services
                <span className='icon-rotate ms-2'> <IoIosArrowDown /> </span></Link>

                    {/* For mobile view */}
                        <div className='mobile-separate mobile-item'>
                        <div className='separate1' >
                            <Link to='/Services' className="nav-link" onClick={() => setMenuOpen (false)}> Services </Link>
                        </div>

                        <div className='separate2' >
                           <div className=" ms-2 nav-link"><span className=' ms-2' onClick={() => setMegaShow (!megaShow)}> <IoIosArrowDown /> </span></div>
                        </div>

                        </div>

                        {/* For mobile view ends */}
                    <div className={"mega-container " + (megaShow && "open")}>
                        <div className="mega-content">
                        {/* Level 1: pillar headings only */}
                        <div className="row mega-left">
                                <ul className="mega-links mega-pillars">
                                    {SERVICE_PILLARS.map((group, i) => (
                                      <li
                                        key={group.pillar}
                                        className={"mega-pillar-item" + (activePillar === i ? " active" : "")}
                                        onMouseOver={() => setActivePillar(i)}
                                        onClick={() => setActivePillar(i)}
                                      >
                                        {group.pillar}
                                        <span> <FaArrowRightLong /> </span>
                                      </li>
                                    ))}
                                </ul>
                        </div>

                        {/* Level 2: services under the selected pillar */}
                        <div className="row mega-right">
                                <ul className="mega-links mega-sublist">
                                    {SERVICE_PILLARS[activePillar].items.map((svc) => (
                                      <li key={svc.id} onClick={() => { setMenuOpen(false); setMegaShow(false); }}>
                                        <HashLink to={`/Services#${svc.id}`} className='mega-link'>
                                          {svc.label}
                                        </HashLink>
                                      </li>
                                    ))}
                                </ul>
                        </div>

                        </div>
                    </div>
                </li>

                <li><Link to='/AWS' className="nav-link" onClick={() => setMenuOpen (false)}>AWS</Link></li>

                <li><Link to='/About' className="nav-link" onClick={() => setMenuOpen (false)}>Who We Are</Link></li>
                <li><Link to='/Careers' className="nav-link" onClick={() => setMenuOpen (false)}>Careers</Link></li>
                <li><Link to='/Contact' className="nav-link" onClick={() => setMenuOpen (false)}>Contact Us</Link> </li>


            </ul>

            <div className='btn menu-btn ms-2 mb-2'>
            <FaBars  onClick={() => setMenuOpen (!menuOpen)} />
            </div>
        </div>
    </nav>
  )
}
